'use client';

import type { FC } from 'react';
import { BottomSheet, FaqSection } from '../../components/ui';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import translations from './ContractFAQSheet.translations';

interface ContractFAQSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ContractFAQSheet: FC<ContractFAQSheetProps> = ({ isOpen, onClose }) => {
  const { t } = useLocalTranslation(translations);

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('title')}>
      <FaqSection>
        <h3>{t('whatIsTitle')}</h3>
        <p>{t('whatIsDescription')}</p>
      </FaqSection>

      <FaqSection>
        <h3>{t('howToUseTitle')}</h3>
        <ol className="ps-6 list-decimal">
          <li>{t('howToUseStep1')}</li>
          <li>{t('howToUseStep2')}</li>
          <li>{t('howToUseStep3')}</li>
          <li>{t('howToUseStep4')}</li>
        </ol>
      </FaqSection>

      <FaqSection>
        <h3>{t('rulesTitle')}</h3>
        <ul className="ps-6 list-disc">
          <li>{t('rulesRule1')}</li>
          <li>{t('rulesRule2')}</li>
          <li>{t('rulesRule3')}</li>
        </ul>
      </FaqSection>
    </BottomSheet>
  );
};
